import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
// import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblem';

const Maintenance: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(135deg, rgba(255,244,236,0.6) 0%, rgba(235,240,255,0.6) 100%)",
        p: 2,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            bgcolor: "#ffffff",
            borderRadius: 3,
            boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            p: { xs: 3, md: 5 },
            textAlign: "center",
            border: "1px solid #F3F4F6",
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              mx: "auto",
              mb: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFF4EC",
              border: "1px solid #FFD8C7",
            }}
          >
            <Typography
              component="span"
              sx={{ fontSize: 38, lineHeight: 1, color: "#FF6844" }}
            >
              🛠️
            </Typography>
          </Box>

          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              color: "#0F202B",
              mb: 1,
              fontSize: {
                xs: `calc(22px * var(--dynamic-font-size, 1)) !important`,
                md: `calc(28px * var(--dynamic-font-size, 1)) !important`,
              },
            }}
          >
            We'll be back shortly
          </Typography>

          <Typography
            sx={{
              color: "#0F202B",
              fontWeight: 600,
              mb: 2,
              fontSize: {
                xs: `calc(14px * var(--dynamic-font-size, 1))`,
                md: `calc(16px * var(--dynamic-font-size, 1))`,
              },
            }}
          >
            Maintenance in progress since 10:00 PM. The website and app are temporarily unavailable. We’ll restore service as soon as we’re done.
          </Typography>

          <Typography
            sx={{
              color: "#64748B",
              mb: 3,
              fontSize: {
                xs: `calc(13px * var(--dynamic-font-size, 1))`,
                md: `calc(15px * var(--dynamic-font-size, 1))`,
              },
            }}
          >
            Please try again later.
          </Typography>

          <Button
            variant="outlined"
            onClick={() => window.location.reload()}
            sx={{
              textTransform: "none",
              borderColor: "#FF7043",
              color: "#FF7043",
              borderRadius: 2,
              px: 3,
              py: 1,
              fontWeight: 600,
              fontSize: { xs: "14px", md: "15px" },
              "&:hover": { borderColor: "#d15435", color: "#d15435" },
            }}
          >
            Refresh
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Maintenance;


